import { ReservationAdapter as CoreReservationAdapter } from '@core/adapters';
import {
  CancelReservationPayload,
  FetchReservationListPayload,
  BlueOneRequestReservationPayload,
  BlueOneRequestReservationResponse,
  BlueOneFetchReservationListResponse,
  FetchReservationAvailableTicketResponse,
  ReservationInfoChangePayload,
} from '@dto';
import { ReservationApiEndpoint } from '@api-endpoint';

export class ReservationAdapter extends CoreReservationAdapter {
  async putReservationCancel(payload: CancelReservationPayload): Promise<void> {
    const { reservationId, cancelResn } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.cancelReservation,
      {
        reservationId,
      }
    );
    await this.http.put<void>(url, { cancelResn });
  }
  async fetchReservationAvailableTicket(payload: {
    timeId: number;
    reservationId?: number;
  }): Promise<FetchReservationAvailableTicketResponse[]> {
    const response = await this.http.get<
      FetchReservationAvailableTicketResponse[]
    >(ReservationApiEndpoint.fetchReservationAvailableTicket, payload);
    return response.data;
  }
  async fetchReservationJoinFlagList(
    payload: FetchReservationListPayload
  ): Promise<BlueOneFetchReservationListResponse> {
    const response = await this.http.get<BlueOneFetchReservationListResponse>(
      ReservationApiEndpoint.fetchReservationList,
      payload
    );
    return response.data;
  }
  async blueOneRequestReservation(
    payload: BlueOneRequestReservationPayload
  ): Promise<BlueOneRequestReservationResponse> {
    const response = await this.http.post<BlueOneRequestReservationResponse>(
      ReservationApiEndpoint.fetchReservationList,
      payload
    );
    return response.data;
  }
  async reservationInfoChange(
    payload: ReservationInfoChangePayload
  ): Promise<void> {
    const { reservationId, ...restPayload } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.updateReservationInfo,
      {
        reservationId: payload.reservationId,
      }
    );
    await this.http.put<void>(url, { ...restPayload });
  }
  async requestUseTicketChange(payload: {
    reservationId: number;
    cardIds: number[];
  }): Promise<void> {
    const { reservationId, cardIds } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.requestUseTicketChange,
      {
        reservationId,
      }
    );
    await this.http.post<void>(url, { cardIds });
  }
  async requestReservationChangeTicketInitCheck(payload: {
    reservationId: number;
    timeId: string;
    visitCnt: number;
  }): Promise<boolean> {
    const { reservationId, timeId, visitCnt } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.requestReservationChangeTicketInitCheck,
      { reservationId }
    );
    const response = await this.http.post<boolean>(url, {
      timeId,
      visitCnt,
    });
    return response.data;
  }
}
